import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Loading, PageHeader, Pagination, SelectSearch } from '../../components';
import SearchByDate from '../../components/SearchByDate/SearchByDate.components';
import {
  getPurchases,
  searchPurchases,
  filterPurchases,
  editPendingPurchaseDetails,
  downloadPurchasesCSV,
} from '../../api/Purchase';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faCheck,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';

import { Drawer } from 'rsuite';

import './ViewPurchases.scss';
import { useGetQueryParams } from '../../hooks/useGetQueryParams';
import { useSetQueryParams } from '../../hooks/useSetQueryParams';
import { APP_PARAMS } from '../../constants/appParams';
import { datesStartOfEndOf, formatDateTime } from '../../utils/dataFormatter';
import { DATE_TIME_TYPES } from '../../constants/dataTimeTypes';
import moment from 'moment';
import FileSaver from 'file-saver';
import { generatePurchaseVoucherPdf } from './PurchaseVoucherPdf';

class ViewPurchases extends Component {
  state = {
    loading: true,
    tabItems: {
      type: [
        { key: 'ALL', label: 'All' },
        { key: 'CREATE', label: 'Create' },
        { key: 'TOPUP', label: 'Top up' },
        { key: 'TRANSFER', label: 'Transfer' },
        { key: 'REGIFT', label: 'Regift' },
        { key: 'EXTRA', label: 'Extra merchant' },
      ],

      status: [
        { key: 'ALL', label: 'All' },
        { key: 'PENDING', label: 'Pending' },
        { key: 'COMPLETE', label: 'Complete' },
      ],
    },
    typeKey: 'ALL',
    statusKey: 'ALL',
    tableheading: {
      header: 'Purchases',
      column: ['ID', 'User ID', 'Voucher ID', 'Total (LKR)', 'Type', 'Status'],
    },
    tableData: [],
    total: 1,
    current: 0,
    fetchError: '',
    notFoundMessage: null,
    searchDropDown: [
      { key: 'PURCHASE', label: 'Purchase ID' },
      { key: 'USER', label: 'User ID' },
      { key: 'VOUCHER', label: 'Voucher ID' },
    ],
    searchPlaceholder: 'Purchase ID',
    searchId: '',
    searchKey: 'PURCHASE',
    startDate: null,
    endDate: null,
    isSearchApiCalled: false,
    isFilterApiCalled: false,
    showPurchaseDrawer: false,
    drawerData: null,
    isClearable: false,

    // Edit states
    isEditing: false,
    editingField: null,
    editDeliveryEmail: '',
    editDeliverySMS: '',
    editScheduledDate: '',
    editInitialValue: '', // Track initial value for comparison
    detailsUpdateLoading: false,
    csvDownloading: false,
    pdfDownloading: false,
  };

  componentDidMount() {
    this.getPurchasesApi(0);
  }

  getPurchasesApi = async (page) => {
    try {
      this.setState({ loading: true, startDate: null, endDate: null });
      const request = {
        typeKey: this.state.typeKey,
        statusKey: this.state.statusKey,
        page,
      };
      const token = this.props.auth.token;
      const response = await getPurchases(request, token);

      this.setState({
        tableData: response.purchasesList,
        total: response.total,
        current: response.current,
        loading: false,
        notFoundMessage: this.getNotFoundMessage(response.purchasesList),
      });
    } catch (err) {
      this.setState({
        fetchError: 'Failed to fetch purchases',
        loading: false,
        tableData: [],
      });
    }
  };

  searchPurchasesApi = async (page) => {
    this.setState({
      loading: true,
      isFilterApiCalled: false,
    });
    try {
      const request = {
        searchKey: this.state.searchKey,
        searchId: this.state.searchId,
        purchaseType: this.state.typeKey,
        page,
      };
      const token = this.props.auth.token;
      const response = await searchPurchases(request, token);

      this.setState({
        tableData: response.purchasesList,
        total: response.total,
        current: response.current,
        loading: false,
        notFoundMessage: this.getNotFoundMessageForSearch(
          response.purchasesList
        ),
      });
    } catch (err) {
      const { searchKey, searchId } = this.state;
      this.setState({
        fetchError: 'Failed to fetch purchases',
        loading: false,
        tableData: [],
        total: 0,
        current: 0,
        notFoundMessage: this.setNotFoundMessageForSearch(searchKey, searchId),
      });
    }
  };

  filterPurchasesApi = async (page, start, end) => {
    this.setState({
      loading: true,
      isSearchApiCalled: false,
      isFilterApiCalled: true,
      searchId: '',
    });
    try {
      const request = {
        startDate: datesStartOfEndOf(start, 'start'),
        endDate: datesStartOfEndOf(end, 'end'),
        purchaseType: this.state.typeKey,
        statusKey: this.state.statusKey,
        page,
      };
      const token = this.props.auth.token;
      const response = await filterPurchases(request, token);

      this.setState({
        tableData: response.purchasesList,
        total: response.total,
        current: response.current,
        loading: false,
        notFoundMessage: this.getNotFoundMessageForFilter(
          response.purchasesList
        ),
      });
    } catch (err) {
      this.setState({
        fetchError: 'Failed to fetch purchases',
        loading: false,
        tableData: [],
      });
    }
  };

  handleDownloadCSV = async () => {
    this.setState({ csvDownloading: true });

    try {
      const request =  {
        startDate: this.state.startDate ? datesStartOfEndOf(this.state.startDate, 'start') : null,
        endDate: this.state.endDate ? datesStartOfEndOf(this.state.endDate, 'end') : null,
        purchaseType: this.state.typeKey ? this.state.typeKey : null,
        statusKey: this.state.statusKey ? this.state.statusKey : null,
      };
      const result = await downloadPurchasesCSV(request, this.props.auth.token);

      let payload = result;
      if (result instanceof ArrayBuffer) {
        payload = new Blob([result], {
           type: 'application/octet-stream' 
        });
      }

      FileSaver.saveAs(payload, `purchases_${formatDateTime(new Date(), DATE_TIME_TYPES.FILE_DATE_TIME)}.csv`);
      this.setState({ csvDownloading: false });
    } catch (error) {
      this.setState({ csvDownloading: false });
      toast.error('Failed to download CSV');
    }
  };

  handleDownloadPdf = async () => {
    this.setState({ pdfDownloading: true });

    try {
      await generatePurchaseVoucherPdf(this.state.drawerData, this.props.auth.token);
      this.setState({ pdfDownloading: false });
    } catch (error) {
      this.setState({ pdfDownloading: false });
      toast.error(error.message || 'Failed to download PDF');
    }
  };

  getNotFoundMessageForSearch = (data) => {
    const { searchKey, searchId } = this.state;
    let notFoundMessage = null;
    if (data.length === 0) {
      notFoundMessage = this.setNotFoundMessageForSearch(searchKey, searchId);
    }
    return notFoundMessage;
  };

  setNotFoundMessageForSearch = (searchKey, id) => {
    let notFoundMessage = null;
    if (searchKey === 'USER') {
      notFoundMessage = `No purchases made by ${id}`;
    } else {
      notFoundMessage = `No purchases found for ${id}`;
    }
    return notFoundMessage;
  };

  getNotFoundMessageForFilter = (data) => {
    const { startDate, endDate } = this.state;
    const start = formatDateTime(startDate, DATE_TIME_TYPES.DATE);
    const end = formatDateTime(endDate, DATE_TIME_TYPES.DATE);
    let notFoundMessage = null;
    if (data.length === 0) {
      notFoundMessage = `No purchases made during ${start} - ${end}`;
    }
    return notFoundMessage;
  };

  getNotFoundMessage = (data) => {
    let notFoundMessage = null;
    if (data.length === 0) {
      const { typeKey, statusKey, tabItems } = this.state;
      const type = tabItems.type.filter((item) => item.key === typeKey);
      const status = tabItems.status.filter((item) => item.key === statusKey);

      if (typeKey !== 'ALL' && statusKey !== 'ALL') {
        notFoundMessage = `No purchases found for type : ${type[0].label} and status : ${status[0].label}`;
      } else if (typeKey === 'ALL' && statusKey !== 'ALL') {
        notFoundMessage = `No purchases found for status : ${status[0].label}`;
      } else if (typeKey !== 'ALL' && statusKey === 'ALL') {
        notFoundMessage = `No purchases found for type : ${type[0].label}`;
      } else {
        notFoundMessage = `No purchases found`;
      }
    }
    return notFoundMessage;
  };

  handlePagination = (page) => {
    if (this.state.isSearchApiCalled) {
      this.searchPurchasesApi(page);
    } else if (this.state.isFilterApiCalled) {
      this.filterPurchasesApi(page, this.state.startDate, this.state.endDate);
    } else {
      this.getPurchasesApi(page);
    }
  };

  handleIdSearch = () => {
    if (!this.state.isClearable) {
      const { searchId } = this.state;
      if (searchId) {
        this.setState({
          isSearchApiCalled: true,
          isFilterApiCalled: false,
          isClearable: true,
        });
        this.searchPurchasesApi(0);
      }
    } else {
      this.handleIdOnClear();
    }
  };

  handleIdOnClear = () => {
    this.setState({
      searchId: '',
      isSearchApiCalled: false,
      isClearable: false,
      notFoundMessage: null,
    });
    this.getPurchasesApi(0);
  };

  searchOnChange = (event) => {
    this.setState({
      searchId: event.target.value,
      isClearable: false,
    });
  };

  onChangeStartDate = (startDate) => {
    const { endDate } = this.state;
    this.setState({ startDate });
    if (startDate && endDate) {
      this.filterPurchasesApi(0, startDate, endDate);
    }
    if (!startDate && !endDate) {
      this.setState({ isFilterApiCalled: false });
      this.getPurchasesApi(0);
    }
  };

  onChangeEndDate = (endDate) => {
    const { startDate } = this.state;
    this.setState({ endDate });
    if (startDate && endDate) {
      this.filterPurchasesApi(0, startDate, endDate);
    }
    if (!startDate && !endDate) {
      this.setState({ isFilterApiCalled: false });
      this.getPurchasesApi(0);
    }
  };

  handleOnClick = (data) => {
    this.setState({
      showPurchaseDrawer: true,
      drawerData: data,
    });
  };

  handleDrawerOnHide = () => {
    this.setState({
      showPurchaseDrawer: !this.state.showPurchaseDrawer,
      editingField: null,
      isEditing: false,
    });
  };

  handleTabOnClick = (key, type) => {
    if (type === 'type') {
      this.setState(
        {
          typeKey: key,
        },
        () => this.getPurchasesApi(0)
      );
    } else {
      this.setState(
        {
          statusKey: key,
        },
        () => this.getPurchasesApi(0)
      );
    }
  };

  handleSearchDropDownOnClick = (key, label) => {
    this.setState({
      searchPlaceholder: label,
      searchKey: key,
      searchId: '',
    });
    this.getPurchasesApi(0);
  };

  // Function to validate edit field
  validateEditField = (field, value) => {
    let error = '';

    switch (field) {
      case 'deliveryEmail':
        if (!value) {
          error = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = 'Invalid email format';
        }
        break;
      case 'scheduledDate':
        if (!value) {
          error = 'Schedule date is required';
        } else {
          const selectedDate = new Date(value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          if (selectedDate < today) {
            error = 'Schedule date cannot be in the past';
          }
        }
        break;
      case 'deliverySMS':
        if (!value) {
          error = 'SMS number is required';
        } else if (!/^\+?[1-9]\d{1,14}$/.test(value)) {
          error = 'Invalid phone number format';
        }
        break;
      default:
        break;
    }

    return error;
  };

  // Function to handle initiating edit mode
  handleEditField = (field) => {
    const { drawerData } = this.state;
    let initialValue = '';

    switch (field) {
      case 'deliveryEmail':
        initialValue = drawerData.deliveryEmail || '';
        break;
      case 'deliverySMS':
        initialValue = drawerData.deliverySMS || '';
        break;
      case 'scheduledDate':
        // Format date to YYYY-MM-DD for date input
        initialValue = drawerData.scheduledDate ? moment(drawerData.scheduledDate).format('YYYY-MM-DDTHH:mm') : '';
        this.setState({ editScheduledDate: initialValue });
        break;
      default:
        break;
    }

    this.setState({
      isEditing: true,
      editingField: field,
      editInitialValue: initialValue,
      [`edit${field.charAt(0).toUpperCase() + field.slice(1)}`]: initialValue,
    });
  };

  // Function to handle canceling edit mode
  handleCancelEdit = () => {
    this.setState({
      isEditing: false,
      editingField: null,
      editDeliveryEmail: '',
      editDeliverySMS: '',
      editscheduledDate: '',
      editInitialValue: '',
    });
  };

  // Function to check if the field has been modified
  hasChanges = () => {
    const { editingField, editInitialValue } = this.state;
    if (!editingField) return false;

    const currentValue = this.state[
      `edit${editingField.charAt(0).toUpperCase() + editingField.slice(1)}`
    ];
    return currentValue !== editInitialValue;
  };

  // Function to handle saving the edited field
  handleSaveEdit = async (page) => {
    const { editingField, drawerData } = this.state;

    const fieldValue =
      this.state[
      `edit${editingField.charAt(0).toUpperCase() + editingField.slice(1)}`
      ];
    const validationError = this.validateEditField(editingField, fieldValue);

    if (validationError) {
      toast.error(validationError);
      return;
    }

    this.setState({ detailsUpdateLoading: true });

    try {
      const payload = {
        pendingVoucherId: drawerData.pendingVoucherId,
        purchaseId: drawerData.id,
        receiverNotifySmsMobileNo: editingField === 'deliverySMS' ? fieldValue : drawerData.deliverySMS,
        receiverNotifyEmail: editingField === 'deliveryEmail' ? fieldValue : drawerData.deliveryEmail,
        emailSmsDeliveryDate: editingField === 'scheduledDate' ? formatDateTime(moment(fieldValue).utc(), DATE_TIME_TYPES.ISO_DATE_TIME_UTC) : null,
        modesOfDelivery: {
          sms: !!(drawerData.deliverySMS || editingField === 'deliverySMS'),
          email: !!(drawerData.deliveryEmail || editingField === 'deliveryEmail'),
        },
      };

      const response = await editPendingPurchaseDetails(payload, this.props.auth.token);

      if (response.message === 'SUCCESSFULLY_UPDATED_PENDING_VOUCHER') {
        if (this.state.startDate && this.state.endDate) {
          this.filterPurchasesApi(0, this.state.startDate, this.state.endDate);
        } else if (this.state.searchId) {
          this.searchPurchasesApi(0);
        } else {
          this.getPurchasesApi(page);
        }
        toast.success(`${editingField} updated successfully`);
        this.setState({
          drawerData: {
            ...drawerData,
            [editingField]: fieldValue,
          },
          isEditing: false,
          editingField: null,
          editValidationError: '',
          detailsUpdateLoading: false,
        });
      } else {
        toast.error('Failed to update field');
      }
    } catch (error) {
      toast.error('Failed to update field');
      this.setState({
        detailsUpdateLoading: false,
      });
    }
  };

  capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  getToFixed = (amount) => {
    return amount
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  renderTableData = () => {
    const { notFoundMessage, loading, tableheading, tableData } = this.state;
    return (
      <Card className='table_div'>
        <div>
          <Table responsive hover>
            <thead>
              <tr>
                {tableheading.column.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {notFoundMessage ? (
                <tr>
                  <td colSpan={6} className='text-center'>
                    {notFoundMessage}
                  </td>
                </tr>
              ) : loading ? (
                <tr>
                  <td colSpan={6} className='text-center'>
                    <Loading text='Loading' />
                  </td>
                </tr>
              ) : (
                tableData.map((data) => {
                  return (
                    <tr
                      key={data.id}
                      className='table_row'
                      onClick={() => {
                        this.handleOnClick(data);
                      }}
                    >
                      <td>{data.id}</td>
                      <td>{data.createdBy ? data.createdBy.id : 'N/A'}</td>
                      <td>{data.voucher ? data.voucher.id : 'N/A'}</td>
                      <td>{data.amount && this.getToFixed(data.amount)}</td>
                      <td>{data.type}</td>
                      <td>{this.capitalize(data.status)}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </Card>
    );
  };

  // Search with the selected "search by" field (re-runs even when a search is
  // already applied, so changing the value and pressing Search just works).
  handleSelectSearch = () => {
    if (!this.state.searchId) return;
    this.setState({
      isSearchApiCalled: true,
      isFilterApiCalled: false,
      isClearable: true,
    });
    this.searchPurchasesApi(0);
  };

  // Clearing the search resets every filter (search, type, status and dates)
  // and reloads the full list once the state has been applied.
  handleSelectSearchClear = () => {
    this.setState(
      {
        searchId: '',
        isClearable: false,
        isSearchApiCalled: false,
        isFilterApiCalled: false,
        notFoundMessage: null,
        typeKey: 'ALL',
        statusKey: 'ALL',
        startDate: null,
        endDate: null,
      },
      () => this.getPurchasesApi(0)
    );
  };

  renderMultipleSearch = () => {
    return (
      <SelectSearch
        options={this.state.searchDropDown}
        selectedKey={this.state.searchKey}
        onSelectChange={this.handleSearchDropDownOnClick}
        value={this.state.searchId}
        onChange={(value) => this.searchOnChange({ target: { value } })}
        onSearch={this.handleSelectSearch}
        onClear={this.handleSelectSearchClear}
        maxLength={10}
      />
    );
  };

  renderFilterByStatus = () => {
    const { statusKey, tabItems } = this.state;
    return (
      <Breadcrumb>
        {tabItems.status.map((item) => {
          const { key, label } = item;
          return (
            <Breadcrumb.Item
              key={key}
              active={key === statusKey}
              onClick={() => {
                this.handleTabOnClick(key, 'status');
              }}
            >
              {label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    );
  };

  renderFilterBlockContents = () => {
    return this.state.tabItems.type.map((item) => {
      const { key, label } = item;
      const active = this.state.typeKey === key;
      return (
        <button
          type='button'
          key={key}
          id={key}
          className={`purchases_type_tab ${active ? 'purchases_type_tab_active' : ''}`}
          aria-pressed={active}
          onClick={() => {
            this.handleTabOnClick(key, 'type');
          }}
        >
          {label}
        </button>
      );
    });
  };

  renderDrawer = () => {
    const data = this.state.drawerData;
    const payment = data && data.payment;
    const user = data && data.createdBy;
    const voucher = data && data.voucher;
    const isComplete = data && data.status === 'COMPLETE';
    const amountRows = isComplete
      ? [
        {
          label: 'Voucher Amount (LKR)',
          value: data && this.getToFixed(voucher ? voucher.amount : data.amount),
          editable: false,
        },
        {
          label: 'Total (LKR)',
          value: data && this.getToFixed(data.amount),
          editable: false,
        },
      ]
      : [
        {
          label: 'Total(LKR)',
          value: data && this.getToFixed(data.amount),
          editable: false,
        },
      ];
    const primaryContent = [
      {
        label: 'Approved By',
        value: data && data.completedByAdmin ? data.completedByAdmin : 'N/A',
        editable: false,
      },
      {
        label: 'User ID',
        value: data && user ? user.id : 'N/A',
        editable: false,
      },
      {
        label: 'Voucher ID',
        value: data && voucher ? voucher.id : 'N/A',
        editable: false,
      },
      { label: 'Type', value: data && data.type, editable: false },
      {
        label: 'Status',
        value: data && this.capitalize(data.status),
        editable: false,
      },
      ...amountRows,
      {
        label: 'Add Ons',
        value: data && data.addOns && Array.isArray(data.addOns) && data.addOns.length > 0 ? data.addOns.map(addOn => addOn.name).join(', ') : 'No Add Ons',
      },
      {
        label: 'Mode of Delivery',
        value: data && data.physicalOption ? data.physicalOption.replace('_', ' ') : 'No Physical Options',
        editable: false,
      },
      {
        label: 'Created Date',
        value:
          data &&
          formatDateTime(data.createdDate, DATE_TIME_TYPES.DATE_TIME_12H),
        editable: false,
      },
      {
        label: 'Schedule Date',
        value:
          data && data.scheduledDate
            ? formatDateTime(data.scheduledDate, DATE_TIME_TYPES.DATE_TIME_12H)
            : 'N/A',
        editable: true,
        field: 'scheduledDate',
      },
      {
        label: 'Delivery Email',
        value: data && data.deliveryEmail,
        editable: true,
        field: 'deliveryEmail',
      },
      {
        label: 'Delivery SMS No.',
        value: data && data.deliverySMS,
        editable: true,
        field: 'deliverySMS',
      },
    ];

    let paymentContent = [];
    if (payment) {
      paymentContent = [
        { label: 'Payee Name', value: data && payment.payeeName },
        {
          label: 'Payment Type',
          value: data && this.capitalize(payment.paymentType),
        },
        {
          label: 'Payment Time',
          value:
            data &&
            formatDateTime(payment.paymentTime, DATE_TIME_TYPES.DATE_TIME_12H),
        },
        {
          label: 'Order Reference No',
          value: data && payment.orderReferenceNumber,
        },
      ];
    }

    return (
      <div className='purchase_drawer_root'>
        <div className='drawer_child'>
          <div className='header_group'>
            <div>
              <span className='header_title'>Purchase ID</span>
              <span className='header_value'> {data && data.id}</span>
            </div>
            <Button
              variant='secondary'
              size='sm'
              onClick={this.handleDownloadPdf}
              disabled={this.state.pdfDownloading || !(data && data.voucher)}
            >
              {this.state.pdfDownloading ? 'Downloading...' : 'Download PDF'}
            </Button>
          </div>
          <div className='details_group'>
            <Accordion defaultActiveKey='0'>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant='link' eventKey='0'>
                    Details
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey='0'>
                  <Card.Body>
                    {' '}
                    {primaryContent.map((item) => {
                      const isEditing =
                        this.state.isEditing &&
                        this.state.editingField === item.field;
                      const hasEditError =
                        isEditing && this.state.editValidationError;

                      return (
                        <div className='detail_group_content'>
                          <span className='content_header'>{item.label}</span>
                          <div className='content_value_wrapper'>
                            {isEditing ? (
                              <div className='edit_field_wrapper'>
                                {item.field === 'scheduledDate' ? (
                                  <Form.Control
                                    type='datetime-local'
                                    value={this.state.editScheduledDate}
                                    onChange={(e) =>
                                      this.setState({
                                        editScheduledDate: e.target.value,
                                      })
                                    }
                                    isInvalid={hasEditError}
                                  />
                                ) : (
                                  <Form.Control
                                    type={
                                      item.field === 'deliveryEmail'
                                        ? 'email'
                                        : 'text'
                                    }
                                    value={
                                      this.state[
                                      `edit${item.field.charAt(0).toUpperCase() +
                                      item.field.slice(1)
                                      }`
                                      ]
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        [`edit${item.field.charAt(0).toUpperCase() +
                                          item.field.slice(1)
                                          }`]: e.target.value,
                                      })
                                    }
                                    isInvalid={hasEditError}
                                  />
                                )}

                                <div className='edit_actions'>
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip>
                                        {!this.hasChanges() ? 'No changes to edit' : 'Save changes'}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-inline-block">
                                      <Button
                                        variant='link'
                                        size='sm'
                                        onClick={() => this.handleSaveEdit(this.state.current)}
                                        disabled={this.state.detailsUpdateLoading || !this.hasChanges()}
                                      >
                                        <FontAwesomeIcon icon={faCheck} />
                                      </Button>
                                    </span>
                                  </OverlayTrigger>
                                  <Button
                                    variant='link'
                                    size='sm'
                                    onClick={this.handleCancelEdit}
                                    disabled={this.state.detailsUpdateLoading}
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              <>
                                <span className='content_value'>
                                  {item.value ? item.value : 'N/A'}
                                </span>
                                {item.editable && data && Number(data.pendingVoucherId) > 0 && (
                                  <Button
                                    variant='link'
                                    size='sm'
                                    className='edit_button'
                                    onClick={() =>
                                      this.handleEditField(item.field)
                                    }
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </Button>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              {data && data.payment && (
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant='link' eventKey='1'>
                      Payment Details
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey='1'>
                    <Card.Body>
                      {paymentContent.map((item) => {
                        return (
                          <div className='detail_group_content'>
                            <span className='content_header'>{item.label}</span>
                            <span className='content_value'>
                              {item.value ? item.value : 'N/A'}
                            </span>
                          </div>
                        );
                      })}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )}
            </Accordion>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { loading, startDate, endDate, total, current, csvDownloading } = this.state;
    return (
      <div className='root__div view_purchases'>
        {loading ? (
          <Loading text='Loading' />
        ) : (
          <div className='root__div_main'>
            <PageHeader text='Purchases' />

            <div className='filter_block'>
              {this.renderFilterBlockContents()}
            </div>

            <div className='purchases_filter_bar'>
              <div className='purchases_filter_status'>
                <span className='purchases_filter_label'>Filter by status</span>
                {this.renderFilterByStatus()}
              </div>
              <div className='purchases_filter_search'>
                {this.renderMultipleSearch()}
              </div>
              <div className='purchases_filter_date'>
                <SearchByDate
                  onStartDateChange={this.onChangeStartDate}
                  onEndDateChange={this.onChangeEndDate}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
              <Button
                variant='primary'
                size='sm'
                className='purchases_download_btn'
                onClick={this.handleDownloadCSV}
                disabled={csvDownloading}
              >
                {csvDownloading ? 'Downloading...' : 'Download CSV'}
              </Button>
            </div>

            {this.renderTableData()}

            {total > 1 && (
              <Pagination
                pageCount={total}
                onChange={this.handlePagination}
                currentPage={current}
              />
            )}
          </div>
        )}
        <Drawer
          show={this.state.showPurchaseDrawer}
          onHide={this.handleDrawerOnHide}
        >
          {this.renderDrawer()}
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(ViewPurchases);
